var map = {
	"./1/1s.jpg": "2a2d",
	"./10/1s.jpg": "77af",
	"./11/1s.jpg": "3132",
	"./12/1s.jpg": "6547",
	"./13/1s.jpg": "9ec7",
	"./14/1s.jpg": "aa9c",
	"./2/1s.jpg": "1513",
	"./3/1s.jpg": "4d91",
	"./4/1s.jpg": "a484",
	"./5/1s.jpg": "69c3",
	"./6/1s.jpg": "1854",
	"./7/1s.jpg": "f36e",
	"./8/1s.jpg": "a648",
	"./9/1s.jpg": "3f62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7096";